import { Box, Button, Dialog, Flex, Text } from '@radix-ui/themes'
import { HelpCircleIcon } from 'lucide-react'
import { useState } from 'react'

import { TutorialsDialog } from './TutorialsDialog'

const STORAGE_KEY = 'com.veekls.skip-new-tutorials-alert'

export const TutorialsButton = () => {
  const [dialogOpen, setDialogOpen] = useState(localStorage.getItem(STORAGE_KEY) !== '1')
  const [tutorialsOpen, setTutorialsOpen] = useState(false)

  return (
    <>
      <Button variant="ghost" onClick={() => setTutorialsOpen(true)}>
        <HelpCircleIcon />
        <Box display={{ initial: 'none', sm: 'block' }} asChild>
          <Text>Ayuda</Text>
        </Box>
      </Button>

      <TutorialsDialog open={tutorialsOpen} onOpenChange={setTutorialsOpen} />

      <Dialog.Root open={dialogOpen} onOpenChange={setDialogOpen}>
        <Dialog.Content>
          <Dialog.Title>¡Nuevos Tutoriales!</Dialog.Title>
          <Dialog.Description>
            Hemos creado unos tutoriales para ayudarte a navegar por la aplicación. Puedes acceder a ellos haciendo
            click en el botón "Ayuda" en la barra de navegación superior.
          </Dialog.Description>
          <Flex justify="between" mt="4">
            <Dialog.Close>
              <Button
                variant="outline"
                onClick={() =>
                  setDialogOpen(() => {
                    localStorage.setItem(STORAGE_KEY, '1')

                    return false
                  })
                }
              >
                <Text>Descartar</Text>
              </Button>
            </Dialog.Close>
            <Dialog.Close>
              <Button
                onClick={() => {
                  setTutorialsOpen(true)
                  setDialogOpen(() => {
                    localStorage.setItem(STORAGE_KEY, '1')

                    return false
                  })
                }}
              >
                <Text>Abrir Tutoriales</Text>
              </Button>
            </Dialog.Close>
          </Flex>
        </Dialog.Content>
      </Dialog.Root>
    </>
  )
}
